const XOS_BRANDING = {
  BLACK: '#000000',
  WHITE: '#FFFFFF',
  PRIMARY: '#FE0300',
  NEUTRAL_GREY: '#F5F5F5',
  GREY: '#C4CDD5',
  WARNING: '#C72D2D',
  SAFE: '#2DC78D',
  LABEL: 'xos',
};

const CATAPULT_BRANDING = {
  BLACK: '#000000',
  WHITE: '#FFFFFF',
  PRIMARY: '#000000',
  NEUTRAL_GREY: '#F5F5F5',
  GREY: '#C4CDD5',
  WARNING: '#FF6600',
  SAFE: '#000000',
  LABEL: 'catapult',
};

export function getProductBrandingForIDM() {
  const brandingOverride = window.localStorage.getItem('idm::branding');
  const brandingOverrideFromUrl = window.location.href.includes('branding=xos');

  if (brandingOverrideFromUrl || brandingOverride === 'xos') {
    return XOS_BRANDING;
  }

  return CATAPULT_BRANDING;
}
